export const TEMPLATES_TAB_TITLE = 'Message Templates';
export const CREATE_TEMPLATE_BUTTON_TEXT = 'New Template';
